import axios from 'axios';
import {ENV_CONFIGS} from '../constants/envs';
import lodashGet from 'lodash/get';
import {tokenExpired} from '../app/actions';
import featureFlags, {FEATURE_FLAGS} from '../utils/featureFlags';

const USER_ENDPOINT = '/users';

export default class {
  constructor(dispatch, accessToken) {
    const defaultHeaders = {'Content-Type': 'application/json'};
    this.token = accessToken?.token;
    this.dispatch = dispatch;
    this.axiosClient = axios.create({
      headers: defaultHeaders
    });
    const shouldIncreaseLimit = featureFlags.get(FEATURE_FLAGS.INCREASE_USER_DELETE_API_LIMIT);
    this.limit = shouldIncreaseLimit ? 200 : 10;
  }

  setAxiosClient(apiConfig) {
    const {projectId} = apiConfig;
    const constructionV1ApiUrl = `${ENV_CONFIGS.APIGEE_HOST}${ENV_CONFIGS.CONSTRUCTION_V1}`;
    this.axiosClient.defaults.baseURL = `${constructionV1ApiUrl}/projects/${projectId}/`;
    this.setInceptors();
  }

  setInceptors() {
    this.axiosClient.interceptors.request.use(config => {
      if (!config.headers) {
        config.headers = {};
      }
      config.headers['Authorization'] = `Bearer ${this.token}`;
      return config;
    });
    this.axiosClient.interceptors.response.use(
      response => response.data,
      error => {
        if (lodashGet(error, 'response.status') === 401) {
          this.dispatch(tokenExpired());
        }
        return Promise.reject(error);
      }
    );
  }

  setConfig(apiConfig) {
    this.setAxiosClient(apiConfig);
  }

  /**
   * Retrieves information about all the deleted users in a project.
   @param {integer} parameters.limit - The maximum number of records to return in a single request. Possible range: 1-200. Default Can be a number between 1 and 200.  Default value: 20.  If a number greater than 200 is provided 200 will be returned.
   @param {integer} parameters.offset - The number of records to skip before returning the result records.  Increase this value in subsequent requests to continue getting results when the number of records exceeds the requested limit.
   **/
  getDeletedProjectUsers({offset, limit}) {
    return this.axiosClient.get(`${USER_ENDPOINT}`, {params: {'filter[status]': 'deleted', offset, limit}});
  }

  getPaginatedDeletedUsersInProject() {
    return this.getDeletedProjectUsers({offset: 0, limit: this.limit});
  }
}
